import JobCardRow from "./JobCardRow";

const JobCardTable = ({ data, onView }) => {
  return (
    <div className="w-[75%] h-[calc(100vh-14em)] lg:h-[calc(100vh-16em)] overflow-scroll">
      <table className="w-full border-collapse text-center">
        <thead>
          <tr className="text-[10px] sticky top-0 lg:text-sm bg-dBlue-100 uppercase tracking-wide rounded-full text-dark-blue [&_th]:px-4 [&_th]:py-2">
            <th className="rounded-l-full">SN</th>
            <th>Status</th>
            <th>Completed Stages</th>
            <th>Started At</th>
            <th>Completed At</th>
            <th className="rounded-r-full">Action</th>
          </tr>
        </thead>
        <tbody className="text-light-black max-lg:text-xs">
          {data.map((item, index) => (
            <JobCardRow
              key={item.id}
              item={item}
              index={index}
              onView={onView}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default JobCardTable;
